import {getPostTopShopIdApi} from "../api/shopApi";
import {getUuidMake} from "../static/js/Common";
import {setOrderWeatherCostApi, setPosWeatherCostApi} from "../api/costApi";
import {shopMapping} from "../static/js/service/mappingService";

export const setWeatherService = async (data) => {
  // pos 정보 조회
  const posShopId = await shopMapping(data.shopId);
  const posTopShop = await getPostTopShopIdApi(posShopId);
  const uuid = getUuidMake(posShopId);

  await setOrderWeatherCostApi(data);

  const posData = {
    channelType: 2,
    uuid: uuid,
    topShopId: posTopShop[0].topShopId,
    shopId: posShopId,
    useStatus: data.enabled ? 1 : 0
  }

  await setPosWeatherCostApi(posData);
}